import { useDocument, useFields } from '@modusign/react-signing';
import {
  createInitialLastInsertedField,
  useSigningState,
  useUIState,
} from '@modusign/react-signing/setup';
import { useDispatch } from 'react-redux';

import useUploadDocumentFile from '@app/hooks/documentSetup/useUploadDocumentFile';
import { usePDF } from '@app/hooks/usePDF';
import { removeFieldOverPageRange } from '@app/libs/fields/removeFieldPageOver';
import { getPdfTotalPage } from '@app/libs/pdf/getPdfPageLength';
import { modalOpen } from '@app/store/modal/actions';
import { FILE_UPLOAD_ERROR_MODAL } from '@app/store/modal/modalTypes';

export default function useDocumentChange() {
  const dispatch = useDispatch();
  const { fields, removeField } = useFields();
  const { initialize } = useSigningState();
  const { ui } = useUIState();
  const { document } = useDocument();
  const { setPDF, resetPDF } = usePDF();
  const { resetInsertingField } = useUIState();

  const { isLoading, mutate } = useUploadDocumentFile({
    onError: (error) => {
      dispatch(modalOpen(FILE_UPLOAD_ERROR_MODAL, { error }));
    },

    onSuccess: async ({ fileId, pdfArrayBuffer, url }) => {
      resetInsertingField();

      initialize({
        document: {
          ...document,
          pdfFile: {
            id: fileId,
            url,
          },
        },
        ui: {
          lastInsertedField: createInitialLastInsertedField(),
          insertingField: null,
          isInOrder: ui.isInOrder,
        },
      });

      /**
       * pdf로드후 pdfContainer는 재로드를 하지 않아서, 한번 null로 세팅 후 재로드를 해줘야함
       */
      resetPDF();
      setPDF(pdfArrayBuffer);

      // TODO: (@Juyeong-Byeon, @DevSDK) 파일 변경 후 react-signing에 file 정보 업데이트 해줄지 논의 후 적용
      const pdfPageLength = await getPdfTotalPage(pdfArrayBuffer);
      removeFieldOverPageRange(fields, pdfPageLength, removeField);
    },
  });

  return {
    isLoading,
    mutate,
  };
}
